import { render, staticRenderFns } from "./EditMeasurements.vue?vue&type=template&id=b9cf5fea"
import script from "./EditMeasurements.vue?vue&type=script&lang=js"
export * from "./EditMeasurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports